import { Identifier } from '@okletsplay/core';
import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { cancelationSubscribe } from 'app/services/api/utils';
import { entityStoreStatus } from 'app/utils/store/entity-store-status';
import { entityAdapter } from './adapter';
import { TournamentBracketState } from './interfaces';
import { TournamentBracketStoreStatus } from './enum';
import { TournamentBracketRoundEntity } from 'app/interfaces/entity';

export const getTournamentBracket = createAsyncThunk(
  `${EntityStoreName.TournamentBracket}/getTournamentBracket`,
  (id: Identifier, { signal }): Promise<TournamentBracketRoundEntity[]> => {
    const cancelToken = cancelationSubscribe(signal);

    return apiRequestCall<TournamentBracketRoundEntity[]>({
      params: {
        method: 'GET',
        resource: ApiResource.Tournaments,
        urlPrefix: `${id}/${ApiResource.Bracket}`,
        cancelToken,
      },
    });
  }
);

// TODO: remove when the bracket header will be removed
export const toggleRoundVisibility = createAsyncThunk(
  `${EntityStoreName.TournamentBracket}/hideRound`,
  (data: { round: string; hidden: boolean }): Promise<{ round: string; hidden: boolean }> => {
    return Promise.resolve(data);
  }
);

export const registerReducers = (
  builder: ActionReducerMapBuilder<TournamentBracketState>
): void => {
  builder
    .addCase(getTournamentBracket.pending, (state, action) => {
      entityStoreStatus.addRequestId(
        state,
        TournamentBracketStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(getTournamentBracket.fulfilled, (state, action) => {
      const payload = action.payload.map((data, index) => ({
        ...data,
        hidden: false,
        order: index,
      }));
      entityAdapter.setAll(state, payload);
      entityStoreStatus.removeRequestId(
        state,
        TournamentBracketStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(getTournamentBracket.rejected, (state, action) => {
      entityStoreStatus.removeRequestId(
        state,
        TournamentBracketStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(toggleRoundVisibility.pending, (state, action) => {
      entityStoreStatus.addRequestId(
        state,
        TournamentBracketStoreStatus.Hiding,
        action.meta.requestId
      );
    })
    .addCase(toggleRoundVisibility.fulfilled, (state, action) => {
      const { round, hidden } = action.payload;
      entityAdapter.updateOne(state, { id: round, changes: { hidden } });
      entityStoreStatus.removeRequestId(
        state,
        TournamentBracketStoreStatus.Hiding,
        action.meta.requestId
      );
    })
    .addCase(toggleRoundVisibility.rejected, (state, action) => {
      entityStoreStatus.removeRequestId(
        state,
        TournamentBracketStoreStatus.Hiding,
        action.meta.requestId
      );
    });
};
